import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { User, Lock, LogIn } from 'lucide-react';
import { destinoSeguroTrasLogin, leerYBorrarDestinoGuardado } from './Login';

const EmpleadoLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const API_URL = process.env.REACT_APP_BACKEND_URL || '';

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/empleados/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.detail || 'Error al iniciar sesión');
      }

      const data = await response.json();
      // Una sola sesión en el navegador: al entrar como empleado se olvida la
      // sesión de administrador que hubiera
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.setItem('empleado_token', data.access_token);
      localStorage.setItem('empleado_info', JSON.stringify(data.empleado));
      
      // Para volver al destino tras entrar (enlaces del móvil y push); si no hay,
      // a la raíz: Mi Inicio hasta fichar y después el calendario (InicioSegunFichaje)
      const guardado = leerYBorrarDestinoGuardado();
      const desde = destinoSeguroTrasLogin(location.state?.desde) || destinoSeguroTrasLogin(guardado);
      window.location.href = desde || '/';
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8">
        <div className="text-center mb-8">
          <div className="inline-block p-3 bg-duetto-primary rounded-full mb-4">
            <User className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Portal del Empleado</h1>
          <p className="text-gray-600 mt-2">Accede a tu información personal</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4" data-login-form="true">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                placeholder="tu.email@empresa.com"
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Contraseña
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                placeholder="••••••••"
                autoComplete="current-password"
                required
              />
            </div>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-duetto-primary text-white py-3 rounded-lg font-medium hover:bg-opacity-90 transition disabled:opacity-50 flex items-center justify-center space-x-2"
          >
            {loading ? (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            ) : (
              <>
                <LogIn className="w-5 h-5" />
                <span>Iniciar Sesión</span>
              </>
            )}
          </button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            ¿Problemas para acceder? Habla con dirección.
          </p>
        </div>

        <div className="mt-6 pt-6 border-t border-gray-200 text-center">
          <a
            href="/"
            className="text-sm text-gray-600 hover:text-duetto-primary transition"
          >
            ← Volver al inicio
          </a>
        </div>
      </div>
    </div>
  );
};

export default EmpleadoLogin;
